/**
 * Per-field help text for template forms. Single source of truth — both the
 * inline <HelpIcon> on the edit form and the right-sidebar Field Help drawer
 * on the /templates/new page read from this map (per entity-management
 * guidelines §4).
 *
 * Keys match form field names one-to-one. When adding a new field, add an
 * entry here first, then reference it from the form.
 */
export const TEMPLATE_FIELD_HELP: Record<string, string> = {
  slug: 'URL-safe identifier (lowercase, hyphens). Used by workflow steps to reference this template. Cannot be changed after creation — pick carefully.',

  title:
    'Short human-readable title shown in lists, pickers, and the chat UI. Example: "Macro Analyst", "Risk Auditor".',

  department:
    'Logical grouping by function: research, risk, execution, compliance, orchestration. Drives default tool tiers and review routing. A template inherits department-level permissions by default.',

  permissionTier:
    'Observer (read-only), Contributor (write to agent workspace), Operator (can act on external systems). Higher tiers bypass more guardrails — raise only when the role genuinely needs it.',

  platform:
    'Optional. If this template specializes for one source (youtube, twitter, arxiv, etc.), name it here. Leave blank for platform-agnostic templates.',

  goal: 'One-line objective. The agent reads this as the first thing in its system prompt — keep it concrete and action-oriented. Example: "Surface macro shifts that change risk assumptions in open positions."',

  backstory:
    'Short narrative that gives the agent its voice and expertise framing. Used to make outputs feel consistent across runs. Not the instructions — this is the "who", not the "what".',

  instructions:
    'The main system prompt. Markdown supported. Use `{{variable}}` syntax for runtime parameters. Keep under 2000 tokens for best results; longer prompts degrade instruction-following.',

  constraints:
    'Hard rules and safety/compliance guardrails. Additive with any parent template when using extends. Example: "Never recommend leveraged positions.", "Cite every external claim."',

  tools:
    "Comma-separated list of tool names the agent is allowed to invoke. Tools must exist in the org's tool registry (created in Tools page or installed from marketplace). Unresolved names are logged on save.",
  disableModelInvocation:
    'Pure orchestrator: skip the LLM entirely and route each task by rule. The first rule whose match string is a case-insensitive substring of the task input dispatches the task to its target template. Deterministic and free — no model call. A pure orchestrator with no rules has nothing to route to.',
};
